import { Alert, Snackbar } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { hideSnackbar } from '../../redux/reducer/snackbarSlice';
import { RootState } from '../../redux/store';

const SnackbarMessage = () => {
    const dispatch = useDispatch();
    const snackbars = useSelector((state: RootState) => state.snackbar.messages);

    const handleClose = (id: number) => {
        dispatch(hideSnackbar(id));
    };

    return (
        <div style={{
            position: 'fixed',
            bottom: 10,
            zIndex: 9999,
            left: 10,
            display: 'flex',
            flexDirection: 'column-reverse',
            gap: '10px',
        }}>
            {snackbars.map((snackbar) => (
                <Snackbar
                    key={snackbar.id}
                    open={true}
                    autoHideDuration={3000}
                    onClose={() => handleClose(snackbar.id)}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    style={{ marginBottom: 10, position: 'relative', marginRight:40 }}
                >
                    <Alert  variant="filled"  onClose={() => handleClose(snackbar.id)} severity={snackbar.type}>
                        {snackbar.message}
                    </Alert>
                </Snackbar>
            ))}
        </div>
    );
}

export default SnackbarMessage;